import { routerActions } from "react-router-redux";
import { arrayMove } from "Utils";

const initialState = {
  blocs: [
    /*{
      type: "BLOG",
      order: 1,
      enabled: true,
      disposition: ["B1", "B1", "B1"],
      titleFR: "",
      subtitleFR: "",
      titleEN: "",
      subtitleEN: "",
      titleNL: "",
      subtitleNL: "",
      conditions: []
    },
    {
      type: "EVENT",
      order: 2,
      enabled: true,
      disposition: ["B1", "B1", "B1"],
      titleFR: "",
      subtitleFR: "",
      titleEN: "",
      subtitleEN: "",
      titleNL: "",
      subtitleNL: "",
      conditions: []
    },
    {
      type: "MEDIA",
      order: 3,
      enabled: true,
      disposition: ["B1", "B1", "B1"],
      titleFR: "",
      subtitleFR: "",
      titleEN: "",
      subtitleEN: "",
      titleNL: "",
      subtitleNL: "",
      conditions: []
    },
    {
      type: "EMAILING",
      order: 4,
      enabled: true,
      disposition: ["B1", "B1", "B1"],
      titleFR: "",
      subtitleFR: "",
      titleEN: "",
      subtitleEN: "",
      titleNL: "",
      subtitleNL: "",
      conditions: []
    }*/
  ],
  bloc: {
    name: "",
    config: [],
    scope: [],
    group: [],
    widgets: [],
    apps: []
  },
  drawer: {
    type: "OTHER",
    order: 5,
    enabled: true,
    label: "",
    url: "",
    icon: "",
    app: ""
  },
  saving: false,
  saved: false,
  error: null
};
export const hubReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_NAV_COMMUNITY": {
      const { community } = action;
      if (
        community &&
        community.hubPreferences &&
        community.hubPreferences.layout_settings
      ) {
        return {
          ...state,
          blocs: community.hubPreferences.layout_settings
        };
      }
      return state;
    }
    case "SET_AUTH": {
      const { navCommunity } = action.auth;
      if (
        navCommunity &&
        navCommunity.hubPreferences &&
        navCommunity.hubPreferences.layout_settings
      ) {
        return {
          ...state,
          blocs: navCommunity.hubPreferences.layout_settings
        };
      }
      return state;
    }

    case "SET_HUB_BLOCS": {
      return { ...state, blocs: [] };
    }

    case "SET_BLOC_STATUS": {
      let help = state.blocs[action.indexSetting].config.map(item => ({
        ...item
      }));
      for (let i = 0; i < help.length; i++) {
        if (help[i].order === action.order) {
          help[i].enabled = action.status;
        }
      }
      let blocs = state.blocs.map(item => ({ ...item }));
      blocs[action.indexSetting].config = help;
      return { ...state, blocs: [...blocs] };
    }

    case "SET_BLOCS_ORDER": {
      let help = arrayMove(
        state.blocs[action.indexSetting].config,
        action.oldIndex,
        action.newIndex
      );
      for (let i = 0; i < help.length; i++) {
        help[i].order = i + 1;
      }
      let blocs = [...state.blocs];
      blocs[action.indexSetting].config = help;
      return {
        ...state,
        blocs: [...blocs]
      };
    }

    case "SET_BLOC_DISPOSITION": {
      let help = [...state.blocs];
      for (let i = 0; i < help.length; i++) {
        if (help[i].order === action.order) {
          help[i].disposition = [...action.disposition];
        }
      }
      return { ...state, blocs: [...help] };
    }

    case "SET_BLOC_TITLE": {
      let help = [...state.blocs[action.indexSetting]];
      for (let i = 0; i < help.length; i++) {
        if (help[i].order === action.order) {
          help[i][`title${action.lng.toUpperCase()}`] = action.value;
        }
      }
      let blocs = [...state.blocs];
      blocs[action.indexSetting] = help;
      return { ...state, blocs: [...blocs] };
    }

    case "SET_BLOC_SUBTITLE": {
      let help = [...state.blocs[action.indexSetting]];
      for (let i = 0; i < help.length; i++) {
        if (help[i].order === action.order) {
          help[i][`subtitle${action.lng.toUpperCase()}`] = action.value;
        }
      }
      let blocs = [...state.blocs];
      blocs[action.indexSetting] = help;
      return { ...state, blocs: [...blocs] };
    }

    case "SET_BLOC_LABEL": {
      let help = [...state.blocs[action.indexSetting].config];
      for (let i = 0; i < help.length; i++) {
        if (help[i].order === action.order) {
          help[i].label = action.value;
        }
      }
      let blocs = [...state.blocs];
      blocs[action.indexSetting].config = help;
      return { ...state, blocs: [...blocs] };
    }

    case "SET_BLOC_URL": {
      let help = [...state.blocs[action.index].config];
      for (let i = 0; i < help.length; i++) {
        if (help[i].order === action.order) {
          help[i].url = action.value;
        }
      }
      let blocs = [...state.blocs];
      blocs[action.index].config = help;
      return { ...state, blocs: [...blocs] };
    }

    case "SET_BLOC_ICON": {
      let help = [...state.blocs[action.index].config];
      for (let i = 0; i < help.length; i++) {
        if (help[i].order === action.order) {
          help[i].icon = action.value;
        }
      }
      let blocs = [...state.blocs];
      blocs[action.index].config = help;
      return { ...state, blocs: [...blocs] };
    }

    case "SET_BLOC_APP": {
      let help = [...state.blocs[action.index].config];
      for (let i = 0; i < help.length; i++) {
        if (help[i].order === action.order) {
          help[i].app = action.value;
        }
      }
      let blocs = [...state.blocs];
      blocs[action.index].config = help;
      return { ...state, blocs: [...blocs] };
    }

    case "SAVE_BLOC_PENDING": {
      return { ...state, saved: false, saving: true };
    }
    case "SAVE_BLOC_FULFILLED": {
      return {
        ...state,
        saved: true,
        saving: false
        // blocs: JSON.parse(action.payload.data)
      };
    }
    case `SAVE_BLOC_REJECTED`: {
      let error = action.payload;
      switch (error.response.status) {
        case 500:
          error = {
            title: error.response.data.title,
            code: 500
          };
          break;
        default:
      }
      return {
        ...state,
        saving: false,
        saved: false,
        error
      };
    }

    // case "ADD_NEW_DRAWER": {
    //   let help = [...state.blocs[action.index].congig];
    //   help.splice(
    //     action.order,
    //     0,
    //     initialState.blocs.filter(bloc => bloc.type === action.blocType)[0]
    //   );
    //   for (let i = action.order; i < help.length; i++) {
    //     help[i] = { ...help[i], order: help[i].order + 1 };
    //   }
    //   let blocs = [...state.blocs];
    //   blocs[action.index] = help;
    //   return {
    //     ...state,
    //     blocs: [...blocs]
    // }

    case "ADD_NEW_BLOC": {
      return {
        ...state,
        blocs: [
          ...state.blocs,
          {
            name: "-",
            config: [],
            scope: [],
            group: [],
            widgets: [],
            apps: []
          }
        ]
      };
    }

    case "DELETE_BLOC": {
      let config = state.blocs[action.index].config.filter(
        bloc => bloc.order !== action.order
      );

      for (let i = action.order - 1; i < config.length; i++) {
        config[i].order--;
      }

      let blocs = [...state.blocs];
      blocs[action.index].config = config;
      return {
        ...state,
        blocs: [...blocs]
      };
    }

    case "ADD_NEW_DRAWER": {
      let help = [...state.blocs[action.index].config];
      help.push({ ...initialState.drawer, order: help.length + 1 });

      let blocs = state.blocs.map(item => ({ ...item }));
      blocs[action.index].config = help;
      return {
        ...state,
        blocs: [...blocs]
      };
    }

    case "ADD_CONDITION": {
      let help = [...state.blocs];
      let condHelp = { ...action.condition };

      let currentIndex = -1;
      for (let i = 0; i < help.length; i++) {
        if (help[i].order === action.order) {
          currentIndex = i;
          break;
        }
      }
      if (currentIndex >= 0) {
        const helpCondition = help[currentIndex].conditions.filter(
          condition => condition.property != condHelp.property
        );

        if (condHelp.value === "DOCUMENT") {
          condHelp.value = ["PDF", "PPT"];
          condHelp.operator = "in";
        }

        helpCondition.push(condHelp);

        help[currentIndex].conditions = [...helpCondition];
      }
      return { ...state, blocs: [...help] };
    }

    case "SET_SCOPE": {
      let blocs = state.blocs.map(item => ({ ...item }));
      blocs[action.index].scope = action.scope;
      return { ...state, blocs: [...blocs] };
    }

    case "SET_GROUP": {
      let blocs = state.blocs.map(item => ({ ...item }));
      blocs[action.index].group = action.group;
      return { ...state, blocs: [...blocs] };
    }

    case "SET_WIDGETS": {
      let blocs = state.blocs.map(item => ({ ...item }));
      blocs[action.index].widgets = action.widgets;
      return { ...state, blocs: [...blocs] };
    }

    case "SET_APPS": {
      let blocs = state.blocs.map(item => ({ ...item }));
      blocs[action.index].apps = action.apps;
      return { ...state, blocs: [...blocs] };
    }

    case "DELETE_SETTING": {
      return {
        ...state,
        blocs: state.blocs.filter((bloc, index) => index !== action.index)
      };
    }

    case "SET_LAYOUT_NAME": {
      let blocs = state.blocs.map(item => ({ ...item }));
      blocs[action.index].name = action.name;
      return { ...state, blocs: [...blocs] };
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/hub.js